import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  useSeo({
    title: '页面未找到 - 啪啪视频',
    description: '你访问的页面不存在，返回啪啪视频首页继续浏览高清视频内容。',
  });

  return (
    <Layout>
      <div className="pt-16">
        <div className="px-4 md:px-6 py-24 text-center">
          <p className="font-heading text-6xl md:text-8xl font-extrabold text-accent-500">404</p>
          <h1 className="mt-5 font-heading text-xl md:text-2xl font-bold text-foreground-950">页面未找到</h1>
          <p className="mt-2 text-sm text-foreground-600">你访问的页面可能已被移除或链接有误。</p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors"
            >
              <i className="ri-home-4-line text-base" />
              返回首页
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-md border border-background-200/70 text-foreground-800 text-sm font-medium hover:border-accent-500 hover:text-accent-500 transition-colors"
            >
              <i className="ri-search-line text-base" />
              去发现视频
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}